<template>
  <div>
    <el-form-item>
      <template #label>
        <h4>
          {{ label }}
          <el-popover
            placement="right"
            title="提示"
            width="400"
            trigger="hover"
            popper-class="popperClass"
            :content="tip"
            v-if="tip"
          >
            <template slot="reference">
              <i class="el-icon-question elOpStyle"></i>
            </template>
          </el-popover>
        </h4>
      </template>
      <el-button type="text" size="medium" @click="chooseMember"
        >添加人员</el-button
      >
      <div v-if="form.length > 0">
        <el-tag
          @close="deleteTag(item)"
          closable
          style="margin-right: 10px"
          v-for="item in form"
          :key="item"
          >{{ username(item) }}</el-tag
        >
      </div>
    </el-form-item>
    <el-dialog
      title="添加对应人员"
      :visible.sync="drawShow"
      @close="cancelShow"
      append-to-body
    >
      <div style="padding: 10px 20px">
        <el-cascader-panel
          :props="optionProps"
          v-model="cascader"
          style="width: 100%; max-height: 50vh"
        ></el-cascader-panel>
        <div style="max-height: 20vh; overflow: auto">
          <el-tag
            @close="deleteNewTag(item)"
            closable
            style="margin: 10px 10px 0 0"
            v-for="item in cascaderList"
            :key="item"
            >{{ username(item) }}</el-tag
          >
        </div>
        <div style="margin-top: 10px; text-align: right">
          <el-button @click="submitFn" type="primary">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findRoleAndUser } from "@/api/roleList";
import { sectionAndUser } from "@/api/department.js";

export default {
  props: ["list", "userList", "data", "type", "label", "tip"],
  name: "UserSelect",
  computed: {
    username() {
      return function (value) {
        return (
          this.userList.find((res) => {
            return res.id == value;
          })?.nickName || ""
        );
      };
    },
    cascaderList() {
      return [...new Set(this.cascader.map((res) => res[1].toString()))];
    },
    form: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
  data() {
    return {
      drawShow: false,
      cascader: [],
      optionProps: {
        expandTrigger: "hover",
        multiple: true,
        lazy: true,
        lazyLoad: this.lazyLoad,
      },
    };
  },
  methods: {
    deleteNewTag(val) {
      let arr = [];
      this.cascader = this.cascader.map((res) => {
        res[1] == val ? "" : arr.push(res);
      });
      this.cascader = arr;
    },
    submitFn() {
      this.form = [...new Set([...this.form, ...this.cascaderList])];
      this.cancelShow();
    },
    deleteTag(value) {
      this.form = this.form.filter((item) => {
        return item != value;
      });
    },
    chooseMember() {
      this.drawShow = true;
    },
    cancelShow() {
      this.drawShow = false;
      this.cascader = [];
    },
    // 获取具体字段懒加载
    getDetails(level, id, resolve) {
      const params = {
        id,
      };
      let fun = this.type == 1 ? findRoleAndUser : sectionAndUser;
      fun(params).then((res) => {
        if (res) {
          let newData = [];
          let targetData = [];
          this.type == 1
            ? (targetData = res.data || [])
            : (targetData = res.data ? res.data.userList : []);
          targetData.map((item) => {
            let params = {
              value: item.id,
              label: item.nickName,
              leaf: level >= 1,
            };
            newData.push(params);
          });
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(newData);
        }
      });
    },
    lazyLoad(node, resolve) {
      const { level } = node;
      if (level == 0) {
        resolve(
          this.list.map((res) => ({
            value: res.id,
            label: this.type == 1 ? res.roleName : res.name,
          }))
        );
      } else if (level == 1) {
        this.getDetails(level, node.value, resolve);
      } else {
        resolve({});
      }
    },
  },
};
</script>
